var React = require('react');

function QuestionHelpLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 31.97a1 1 0 01-1-1v-2.22a3 3 0 012.43-2.94 6.5 6.5 0 003.16-10.95 6.448 6.448 0 00-4.59-1.9 6.51 6.51 0 00-6.49 6.52 1 1 0 11-2 0A8.51 8.51 0 0124 10.96a8.51 8.51 0 011.84 16.81 1 1 0 00-.84 1v2.21a1 1 0 01-1 .99zm0 6.01a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-2a.5.5 0 100 1 .51.51 0 00.5-.5.5.5 0 00-.5-.5z","key":0}),React.createElement("path",{"d":"M24 48a24 24 0 110-48 24 24 0 010 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":1})]);
}

QuestionHelpLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = QuestionHelpLight;

QuestionHelpLight.default = QuestionHelpLight;
